import { gql } from '@apollo/client';

export const UPSERT_PROGRAMME = gql`
  mutation upsertProgramme($input: UpsertProgrammeInput!) {
    programme: upsertProgramme(input: $input) {
      id
      name
    }
  }
`;

export const UPSERT_PROGRAMME_OVERVIEW = gql`
  mutation upsertProgrammeOverview($input: UpsertProgrammeOverviewInput!) {
    programme: upsertProgrammeOverview(input: $input) {
      id
      name
      frameworkResults {
        id
        type
        number
        description
        default {
          id
        }
        level {
          id
          level
        }
        parentResult {
          id
        }
        indicators {
          id
          measurementUnit
          type
          unit
          name
          startDate
          endDate
          target
          targetValue
          description
          resultRelationship
          hasTargets
          hasBaseline
          minValueAllowed
          maxValueAllowed
          dataSources
          outcomeTheme {
            id
            name
          }
          period {
            id
            name
          }
          dimensions {
            id
            index
            name
            options
          }
          benchmarks {
            id
            index
            name
            description
            benchmark {
              id
              name
              description
            }
          }
          periods {
            id
            periodDate
            periodNumber
            label
          }
          targets {
            id
            value
            periodDate
            periodNumber
            dimensionOptions
          }
        }
      }
    }
  }
`;

export const UPSERT_PROGRAMME_INDICATORS = gql`
  mutation upsertProgrammeIndicators($input: UpsertProgrammeIndicatorsInput!) {
    programme: upsertProgrammeIndicators(input: $input) {
      id
      name
    }
  }
`;

export const UPSERT_PROGRAMME_MONITORING = gql`
  mutation upsertProgrammeMonitoring($input: UpsertProgrammeMonitoringInput!) {
    programme: upsertProgrammeMonitoring(input: $input) {
      id
      name
    }
  }
`;
